import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetUniversalPatientVisitDataList = async (searchData, orgId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetAccountPatientVistList?searchData=${searchData}&orgId=${orgId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPatientVisitDataList = async (requestData) => {
    //debugger;
    //console.log(requestData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetFilteredPatientVistList`, JSON.stringify(requestData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

//RA
export const GetPartnerStatemntTransactionData = async (requestData) => {
    //debugger;
    //console.log(requestData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/Get_RA_PP_ClientStatement`, JSON.stringify(requestData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPatientTestsDetailsByVID = async (vid, orgId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetPatientTestsDetailsByVID?vid=${vid}&orgId=${orgId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


//CC
export const CC_GetPartnerStatemntTransactionData = async (requestData) => {
    //debugger;
    //console.log(requestData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/Get_CC_PP_ClientStatement`, JSON.stringify(requestData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerList = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const ValidatePartnerExist = async (partnerCode) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/ValidatePartnerExist?partnerCode=${partnerCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const UpdatePartnerAddress = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/UpdatePartnerAddress`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CreatePartner = async (data) => {
    //debugger;
    // //console.log(JSON.stringify(data))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/SavePartner`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdatePartner = async (data) => {
    //debugger;
    // //console.log(data)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/UpdatePartner`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const EditPartner = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/EditPartnerDetails`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ActivateDeactivatePartner = async (Id, refPartnerId, IsActive) => {

    const response = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/ActivateDeactivatePartnerDetail?id=${Id}&refPartnerId=${refPartnerId}&isActive=${IsActive}`, CommonVariables.API_HEADER))
        .then(response => response);
    return response;
}

//Send Report
// export const SendReportOnEmail = async (fileURL, vid, visit_date, toEmail) => {
//     //debugger;
//     var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/SendReportOnEmail?fileURL=${fileURL}&vid=${vid}&visit_date=${visit_date}&toEmail=${toEmail}`, CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }

export const SendReportOnEmail = async (sendEmailDet) => {
    const response = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Document/SendReportOnEmail`, sendEmailDet, CommonVariables.API_HEADER))
        .then(response => response);
    return response;;
}


//download bulk report
export const BulkReportDownload = async (rptList) => {
    const response = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/BulkReportDownload`, rptList, CommonVariables.API_HEADER))
        .then(response => response);
    return response;;
}

export const GetPartner_StaffLoginHistory = async (partner_code) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartner_StaffLoginHistory?partner_code=${partner_code}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetActivePartnerList = async (Parent_UserId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetActivePartnerList?parent_userId=${Parent_UserId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerUserDependedFeildDataList = async (partner_code) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerUserDependedFeildDataList?partner_code=${partner_code}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerExtensionList = async (parent_partner_code, parent_userid) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerExtensionList?parent_partner_code=${parent_partner_code}&parent_userid=${parent_userid}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const SavePartnerExtension = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/SavePartnerExtension?`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdatePartnerExtension = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/UpdatePartnerExtension?`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const DeletePartnerExtension = async (Id) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/DeletePartnerExtension?Id=${Id}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ActivateDeactivatePartnerExtension = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/ActivateDeactivatePartnerExtension?`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetAllPartnerExtensionList = async (parent_partner_code, parent_userid) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetAllPartnerExtensionList?parent_partner_code=${parent_partner_code}&parent_userid=${parent_userid}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerListByEmail = async (email) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerListBySalesOwnerEmail?salesAdminEmail=${email}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetSalesTeamDetailsByManagerEmail = async (email) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetSalesTeamDetailsByManagerEmail?email=${email}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const BulkPartnerStaffOnboard = async (formData) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `CRM_Integration/BulkPartnerStaffOnboard_MetLink`, formData, CommonVariables.API_FILE_HEADER)).then(response => response);
    return result;
}

export const DownloadBulkPartnerTemplate = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/DownloadBulkPartnerTemplate`, { ...CommonVariables.API_HEADER, responseType: "blob" })).then(response => response);
    return result;
}
